<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="新建"
      width="900px"
      append-to-body
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="文件类型" prop="type">
            <el-select v-model="model.type" placeholder="请选择文件类型" @change="typeChange">
              <el-option label="文件夹" :value="16"/>
              <el-option label="文件" :value="128"/>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 文件夹 -->
        <div v-if="model.type === 16">
          <el-col :span="12">
            <el-form-item label="资料名称" prop="name">
              <el-input v-model.trim="model.name" placeholder="请输入资料名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="存放目录" prop="parendIds">
              <el-cascader
                  v-model="model.parendIds"
                  placeholder="请选择存放目录"
                  style="width: 100%"
                  :options="catalogue"
                  :props="defaultProps1"
                  filterable
              />
            </el-form-item>
          </el-col>
        </div>
        <!-- 文件 -->
        <div v-else>
          <el-col :span="12">
            <el-form-item label="发布类型" prop="releaseType">
              <el-select v-model="model.releaseType" placeholder="请选择发布类型" @change="releaseTypeChange">
                <el-option label="新发布" :value="10"/>
                <el-option label="版本升级" :value="20"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="model.releaseType === 20" :span="12">
            <el-form-item label="资料名称" prop="name">
              <el-input v-model="model.name" placeholder="请选择资料" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.fileSelect.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-else :span="12">
            <el-form-item label="资料名称" prop="name">
              <el-input v-model.trim="model.name" placeholder="请输入资料名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料号" prop="materialNo">
              <el-input v-model.trim="model.materialNo" placeholder="请输入物料号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资料类型" prop="fileType">
              <el-select v-model="model.fileType" filterable placeholder="请选择资料类型">
                <el-option v-for="item in fileTypeList" :key="item.itemName" :label="item.itemName" :value="+item.itemValue"/>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="资料权限" prop="fileAuthority">
              <el-select v-model="model.fileAuthority" placeholder="请选择资料权限">
                <el-option label="查看" :value="10"></el-option>
                <el-option label="下载" :value="20"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col v-if="model.releaseType === 20" :span="12">
            <el-form-item label="处理方式" prop="previousVersionTreatment">
              <el-select v-model="model.previousVersionTreatment" placeholder="请选择上个版本处理方式">
                <el-option label="保留" :value="10"/>
                <el-option label="下架" :value="20"/>
                <el-option label="删除" :value="30"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布版本" prop="guidFileList">
              <el-upload
                  class="upload-demo"
                  :limit="1"
                  :file-list="model.guidFileList"
                  :action="uploadBaseUrl + 'pans/uploadFile'"
                  :on-success="guidUpload"
                  :on-remove="handleRemove1"
              >
                <el-button size="mini" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="可编辑版本" prop="editableFileGuidFileList">
              <el-upload
                  class="upload-demo"
                  :file-list="model.editableFileGuidFileList"
                  :limit="1"
                  :action="uploadBaseUrl + 'pans/uploadFile'"
                  :on-success="editGuidUpload"
                  :on-remove="handleRemove2"
              >
                <el-button size="mini" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布对象" prop="roleIds">
              <el-select v-model="model.roleIds" filterable multiple placeholder="请选择发布对象,支持关键字查询">
                <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="model.releaseType == 10" :span="24">
            <el-form-item label="存放目录" prop="parendIds">
              <el-cascader
                  v-model="model.parendIds"
                  placeholder="请选择存放目录"
                  style="width: 100%"
                  :options="catalogue"
                  :props="defaultProps"
                  filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="注意事项" prop="note">
              <el-input v-model.trim="model.note" type="textarea" autosize placeholder="请输入资料使用注意事项"/>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
    <fileSelect ref="fileSelect" @select="fileSelect"/>
  </el-dialog>
</template>

<script>
  import fileSelect from "./FileSelect.vue";
  export default {
    components: { fileSelect },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        fileTypeList: [],
        roleList: [],
        model: {
          type: 16,
          releaseType: "",
          name: "",
          materialNo: "",
          fileType: "",
          // fileAuthority: 20,
          roleIds: [],
          parendIds: [],
          parendId: "",
          note: "",
          guid: "",
          guidFileList: [],
          editableFileGuid: "",
          editableFileGuidFileList: [],
          previousVersionTreatment: "",
        },
        ruleValidate: {
          name: { required: true, message: "资料名称不能为空", trigger: "blur" },
          releaseType: { required: true, message: "发布类型不能为空", trigger: "change" },
          fileType: { required: true, message: "资料类型不能为空", trigger: "change" },
          // fileAuthority: { required: true, message: "资料权限不能为空", trigger: "change" },
          roleIds: { required: true, message: "发布对象不能为空", trigger: "change" },
          parendIds: { required: true, message: "存放目录不能为空", trigger: "change" },
          guidFileList: { required: true, message: "请上传发布版本", trigger: "change" },
          previousVersionTreatment: { required: true, message: "请选择上个版本处理方式", trigger: "change" },
        },
        catalogue: [],
        defaultProps: { expandTrigger: "hover", label: "name", value: "id" },
        defaultProps1: { checkStrictly: true, expandTrigger: "hover", label: "name", value: "id" },
        uploadBaseUrl: window.config.basicServerHttpUrl,
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getFileType();
          this.getFolderCatalogue();
          // const arr = localStorage.getItem("catalogue");
          // if (arr) {
          //   this.catalogue = JSON.parse(arr);
          // } else {
          //   this.getFolderCatalogue();
          // }
          if (row) {
            this.model = Object.assign(this.model, row);
            this.model.guidFileList = [];
            this.model.editableFileGuidFileList = [];
            console.log(row);
            if (row.guid) {
              this.model.guidFileList.push({
                name: row.guid,
              // key: row.guid,
              });
            }
            if (row.editableFileGuid) {
              this.model.editableFileGuidFileList.push({
                name: row.editableFileGuid,
              // key: row.editableFileGuid,
              });
            }
          }
        });
      },

      // 资料类型
      getFileType() {
        this.$http.get("basic", "pans/getFileType").then((res) => {
          this.fileTypeList = res;
          this.getRole();
        });
      },

      // 发布对象
      getRole() {
        this.$http.get("basic", "roles/list").then((res) => {
          this.roleList = res;
        });
      },

      typeChange(value) {
        // this.$refs.form.clearValidate();
        this.$refs.form.resetFields();
        this.model.type = value;
        this.model.parendId = 0;
        this.model.guid = "";
        this.model.editableFileGuid = "";
      },

      releaseTypeChange() {
        this.model.name = "";
        this.model.parendId = "";
      },

      // 存放目录
      getFolderCatalogue() {
        this.$http.get("basic", "pans/tree", { flag: 1 }).then((res) => {
          this.catalogue = res;
          // localStorage.setItem("catalogue", JSON.stringify(res));
        });
      },

      // 发布版本
      guidUpload(res, file, fileList) {
        this.model.name = file.name;
        this.model.guid = res.newName;
        this.model.guidFileList = fileList;
      },

      // 可编辑版本
      editGuidUpload(res, file, fileList) {
        this.model.editableFileGuid = res.newName;
        this.model.editableFileGuidFileList = fileList;
      },

      // 删除文件
      handleRemove1(file, fileList) {
        this.model.guidFileList = fileList;
        this.model.guid = "";
      },

      handleRemove2(file, fileList) {
        this.model.editableFileGuidFileList = fileList;
        this.model.editableFileGuid = "";
      },

      // 选择文件
      fileSelect(row) {
        this.model.parendId = row.parendId;
        this.model.name = row.name;
        this.model.oldFileId = row.id;
      },

      // 确定
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.model.releaseType === 10 || this.model.type === 16) {
              if (this.model.parendIds.length>0) {
                this.model.parendId = this.model.parendIds[this.model.parendIds.length - 1];
              }
            }
            let temp = JSON.stringify(this.model);
            console.log(temp);
            this.$emit("save-success", temp);
            this.dialogVisible = false;
            // console.log(temp);
            // console.log(this.model);
          }
        });
      },
    },
  };
</script>
